import * as React from 'react';
import { Selectors } from '@grandvisionhq/auth';
import { MediaQuery, Logo, SupportFooter } from '@grandvisionhq/common';
import { Alert } from '@grandvisionhq/iris-ui';
import { SplitPane } from '@grandvisionhq/layout';
import { useIntl, useStore, useSelector } from '@grandvisionhq/state';
import '../models/cart/cart-state.js';
import { CheckoutStepErrorType } from '../models/checkout/checkout-step-error-type.js';
import '../models/checkout-settings.js';
import '../models/step-shipping/shipping-methods.js';
import { StepNames } from '../models/shared.js';
import '@grandvisionhq/carts-v2';
import '../context/CheckoutSettings/context.js';
import '@swc/helpers';
import { getSelectedShippingMethod } from '../StepShipping/selectors.js';
import '@grandvisionhq/elements';
import '@grandvisionhq/icons';
import '@grandvisionhq/locations';
import '../StepShipping/modules/ShippingMethods/containers/PickupPointsFinderContainer.js';
import '../StepShipping/modules/ShippingMethods/containers/StoresFinderContainer.js';
import '@grandvisionhq/utils';
import '../mappers/errors-mapping.js';
import '@grandvisionhq/graphql';
import '@grandvisionhq/payments';
import '@grandvisionhq/api-client';
import '../selectors.js';
import '@grandvisionhq/lib-utils-cart';
import '../operations/mutations/set-customer-details.js';
import '../operations/mutations/set-shipping-method.js';
import '../operations/mutations/set-store.js';
import '../operations/mutations/create-apple-pay-session.js';
import '../operations/mutations/recreate-ordered-checkout.js';
import 'lodash/isEmpty';
import '../utils/get-customer-details-payload.js';
import 'history';
import '../utils/has-cart-errors.js';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/fun-orders';
import '@grandvisionhq/analytics';
import '@grandvisionhq/shipping';
import '@grandvisionhq/forms';
import '../state.js';
import 'classnames';
import '../modules/ExpressCheckout/components/ExpressCheckoutContainer.js';
import 'framer-motion';
import '../slots/forms/form-context.js';
import '../slots/summaries/summary-context.js';
import '../slots/summaries/types.js';
import '../modules/ServiceStore/containers/ServiceStoreContainer.js';
import '@grandvisionhq/stores-v2';
import { NavigationContainer } from '../modules/Navigation/NavigationContainer.js';
import '@grandvisionhq/bloomreach';

const CheckoutLayout = ({ showNavigation , logo , status , currentStep , pageRouteRoot , leftContentSection , cartContentSection  })=>{
    const isOverviewStep = currentStep === StepNames.Overview;
    const isShippingStep = currentStep === StepNames.Shipping;
    const { getLabel  } = useIntl();
    const headerRef = React.useRef(null);
    const store = useStore();
    const isLoggedIn = Selectors.isLoggedIn(store.getState());
    const currentBreakpoint = MediaQuery.useBreakpoint();
    const isMobile = currentBreakpoint === MediaQuery.BreakpointName.TABLET_PORTRAIT || currentBreakpoint === MediaQuery.BreakpointName.PHONE;
    const selectedShippingMethod = useSelector(getSelectedShippingMethod);
    React.useEffect(()=>{
        headerRef.current && headerRef.current.scrollIntoView();
    }, []);
    /**
   *  check status of payment through
   *  url query params
   */ const isFailedCheckoutStep = status === CheckoutStepErrorType.Failed;
    const isFailedShippingStep = status === CheckoutStepErrorType.ShippingStepFailed;
    return /*#__PURE__*/ React.createElement("div", {
        className: "checkout-section"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "checkout-section__header",
        ref: headerRef
    }, logo && /*#__PURE__*/ React.createElement(Logo, {
        className: "checkout-section__logo",
        url: pageRouteRoot,
        image: logo
    }), showNavigation && /*#__PURE__*/ React.createElement(NavigationContainer, {
        currentStep: currentStep,
        isLoggedIn: isLoggedIn
    })), /*#__PURE__*/ React.createElement(SplitPane, {
        main: /*#__PURE__*/ React.createElement("div", {
            className: "checkout-section--main"
        }, isMobile && !isOverviewStep && /*#__PURE__*/ React.createElement("div", {
            className: "checkout-section__cart"
        }, cartContentSection), /*#__PURE__*/ React.createElement("div", {
            className: "checkout-section__body"
        }, isFailedCheckoutStep && /*#__PURE__*/ React.createElement(Alert, {
            className: "alert-m-default checkout-section__alert",
            variant: "warning",
            title: getLabel('checkout.errors.general.title')
        }, getLabel('checkout.errors.general.message')), isFailedShippingStep && /*#__PURE__*/ React.createElement(Alert, {
            className: "alert-m-default checkout-section__alert",
            variant: "warning",
            title: getLabel('checkout.errors.general.shipping.title')
        }, getLabel('checkout.errors.general.shipping.message')), !(selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.isValid) && (selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.isTouched) && isShippingStep && /*#__PURE__*/ React.createElement(Alert, {
            className: "alert-m-default checkout-section__alert",
            variant: "warning",
            title: getLabel('checkout.warning.invalid.delivery.title')
        }, getLabel('checkout.warning.invalid.delivery.message')), leftContentSection)),
        aside: /*#__PURE__*/ React.createElement("div", {
            className: "checkout-section--aside"
        }, !isMobile && /*#__PURE__*/ React.createElement("div", {
            className: "checkout-section__cart"
        }, cartContentSection ? cartContentSection : null), /*#__PURE__*/ React.createElement("div", {
            className: "checkout-section__support-footer"
        }, /*#__PURE__*/ React.createElement(SupportFooter, {
            message: getLabel('support.title'),
            phoneNumber: getLabel('support.phoneNumber', {
                hideLabelKey: true
            }) || undefined,
            email: getLabel('support.emailAddress', {
                hideLabelKey: true
            }) || undefined
        })))
    }));
};

export { CheckoutLayout };
//# sourceMappingURL=CheckoutLayout.js.map
